import React, { Component, PropTypes } from 'react';

let $ = window.jQuery;

export default class MultipleEmailType extends Component {
	static PropTypes = {
		val : PropTypes.string,
		label : PropTypes.string,
		id : PropTypes.string,
		email_type : PropTypes.any
	}

	state = {
		val : '',
		email_type : 1
	}

	handleEmailType = (e) => {
		this.setState({
			email_type : e.target.value
		},() => {
			this.props.updateEmailArray(this.state.val, this.props.index, this.state.email_type);
		});
	}

	handleClick = (e) => {
		e.preventDefault();
		let el = $(e.target);
		let emailField = el.parents('.perContainer').find('input');

		// eslint-disable-next-line
		if(emailField.val().trim() == '') //validate
		{
			emailField.focus();
			return;
		}

		this.props.addToArray(el.hasClass('addEmail'),this.props.index);		
	}

	handleOnInputs = (e) => {

		this.setState({
			val : e.target.value
		},() => {
			this.props.updateEmailArray(this.state.val, this.props.index, this.state.email_type);
		})
	}

	componentDidMount() {
		this.setState({
			val : this.props.val,
			email_type : this.props.emailType
		})
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			val : nextProps.val,
			email_type : nextProps.emailType
		})
	}

	render () {

		let className = this.state.val ? 'form-control phoneInput edited' : 'form-control phoneInput';
		let buttonClass = 'fa fa-times remove';
		let buttonColor = "red remove"

		if (this.props.index === this.props.totalIndex - 1) {
            buttonColor = "blue addEmail";
            buttonClass = 'fa fa-plus addEmail';
        }

		return (
			<div className="form-group form-md-line-input form-md-floating-label perContainer">
				<div className="input-group">
                    <div className="input-group-control">
                    	<input type="email" className={className}
                           name={this.props.emailName}
                           value={this.state.val}
                           onChange={this.handleOnInputs} />
                        <label htmlFor="">{this.props.label}</label>
                    </div>
                    &nbsp;
                    <div className="input-group-control">
                        <select name={this.props.typeName} className="form-control" value={this.state.email_type}
                                onChange={this.handleEmailType} >
                            <option value="1">Personal</option>
                            <option value="2">Company</option>
                        </select>
                        <label className="control-label">&nbsp;</label>
                    </div>
                    <span className="input-group-btn btn-right">
                        <a href="#" className={"btn btn-circle btn-icon-only " + buttonColor} onClick={this.handleClick}>
                            <i className={buttonClass}></i>
                        </a>
                    </span>
                </div>
			</div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/MultipleEmailType.js
 **/